import React, { useEffect } from 'react';
import DashboardCard from 'components/DashboardCard/DashboardCard';
import { Add, Description } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from '@tanstack/react-router';
import { actions } from './Reports.redux';
import ModalContentBlockAddNew from './ModalContentBlockAddNew';
import ContentBlocksCell from 'pages/Reports/ContentBlocksCell';
import NumberedDataGridPagination from 'components/NumberedDataGridPagination';

const ContentBlocksList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const loading = useSelector((state) => state.reports.loading);
    const { rows, totalRows, pageSize, pageNumber } = useSelector((state) => state.reports.contentBlocks);

    const columns = [
        { field: 'string_name', headerName: 'Content Block Title', flex: 1, minWidth: 220, sortable: false },
        { field: 'autofill_shortcut', headerName: 'Quick-fill Shortcut', flex: 1, minWidth: 180, sortable: false },
        { field: 'date_created', headerName: 'Created', flex: 1, minWidth: 150, sortable: false },
        { field: 'date_updated', headerName: 'Updated', flex: 1, minWidth: 150, sortable: false },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 120,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => <ContentBlocksCell {...params} />,
        },
    ];

    const handlePaginationModelChange = (newModel) => {
        if (loading) {
            return;
        }

        dispatch(actions.setSubState('contentBlocks', { pageNumber: newModel.page, pageSize: newModel.pageSize }));
        dispatch(actions.loadContentBlocks());
    };

    useEffect(() => {
        if (loading === false) {
            dispatch(actions.loadContentBlocks());
        }
    }, [loading, dispatch]);

    return (
        <DashboardCard
            color={'amber'}
            icon={<Description />}
            topContent={'Content Blocks'}
            topLabel={
                <div>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<Add />}
                        onClick={() => dispatch(actions.setState({ showNewContentBlockModal: true }))}
                    >
                        Add New
                    </Button>
                </div>
            }
            size="xl"
        >
            <div style={{ width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowId={(row) => row.string_id}
                    rowCount={Number(totalRows) || 0}
                    pagination
                    paginationMode="server"
                    pageSizeOptions={[5, 10, 20, 30]}
                    paginationModel={{ page: pageNumber, pageSize }}
                    onPaginationModelChange={handlePaginationModelChange}
                    loading={loading}
                    disableRowSelectionOnClick
                    disableColumnMenu
                    disableCellFocus
                    sx={{
                        '& .MuiDataGrid-row': { cursor: 'pointer' },
                        '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none' },
                        '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                            outline: 'none',
                        },
                    }}
                    slots={{ pagination: NumberedDataGridPagination }}
                    onRowClick={(params) => {
                        if (params.field !== 'actions') {
                            navigate({ to: `/reports/edit-content-block/${params.row.string_id}` });
                        }
                    }}
                    autoHeight
                />
            </div>

            <ModalContentBlockAddNew />
        </DashboardCard>
    );
};

export default ContentBlocksList;
